import { mapActions, mapGetters } from 'vuex'
import Comments from '@/components/Comments'
import { prefixedField } from '@/_helpers/utils'

export default {
  props: {
    // field name props: these props are used to make up the actual
    // field name as used by `prefixedField`
    fieldName: String,
    farmId: { type: Number, default: null },
    fieldPrefix: String,
    // end field name props
    addComment: Boolean,
    addEmailNotification: Boolean,
    commentFieldName: String,
    disabled: Boolean,
    label: String,
    modelName: String,
    subtext: String,
    vvalidate: String,
    showInputBox: {type: Boolean, default: true},
    showLabel: { type: Boolean, default: true },
  },
  components: {
    Comments,
  },
  methods: {
    ...mapActions('currentConsult', ['setFieldValue']),
    prefixedField: prefixedField,
  },
  computed: {
    ...mapGetters('currentConsult', ['hasErrors', 'errorsFor', 'isReadOnly', 'getFieldValue']),
    getIsReadOnly()
    {
      return this.isReadOnly || this.disabled
    },
    getCommentfieldName() 
    {
      return this.commentFieldName ? this.commentFieldName : this.getFieldName
    },
    isFarmField: function () 
    {
      return Boolean(this.farmId)
    },
    getFieldName: function () 
    {
      return this.isFarmField ? this.prefixedField(this.fieldName, this.farmId, this.fieldPrefix) : this.fieldName
    },
    inputVal: {
      get() 
      {
        return this.getFieldValue(this.getFieldName, this.modelName)
      },
      set(val) 
      {
        let payload = {
          fieldName: this.getFieldName,
          value: val,
          modelName: this.modelName,
        }

        this.setFieldValue(payload)
        this.$emit('on-change', payload)
      },
    },
  },
}
